<template>
<v-card class="pa-4 box-shadow-custom">
    <v-tabs v-model="tab" show-arrows>
        <v-tab class="text-capitalize" to="/profile/account">
            <v-icon left>mdi-account</v-icon>
            Account
        </v-tab>
        <v-tab class="text-capitalize" to="/profile/change">
            <v-icon left>mdi-lock</v-icon>
            Change Password
        </v-tab>
        <v-tab class="text-capitalize" to="/profile/team">
            <v-icon left>mdi-account-supervisor</v-icon>
            Team
        </v-tab>
        <v-tab class="text-capitalize" to="/profile/domain">
            <v-icon left>mdi-web</v-icon>
            Whitelabel Domain
        </v-tab>
        <v-tab-item value="/profile/account">
            <Account />
        </v-tab-item>
        <v-tab-item value="/profile/change">
            <ChangePassword />
        </v-tab-item>
        <v-tab-item value="/profile/team">
            <Team />
        </v-tab-item>
        <v-tab-item value="/profile/domain">
            <Domain />
        </v-tab-item>
    </v-tabs>
</v-card>
</template>

<script>
export default {
    components: {
        Team: () => import('../components/Account/Team'),
        ChangePassword: () => import('../components/Account/ChangePassword'),
        Account: () => import('../components/Account/AccountDetails'),
        Domain: () => import('../components/Account/Domain')
    },
    data() {
        return {
            tab: null
        }
    }
}
</script>
